import { render, staticRenderFns } from "./JianKang_quesmana.vue?vue&type=template&id=468c9c48&scoped=true"
import script from "./JianKang_quesmana.vue?vue&type=script&lang=js"
export * from "./JianKang_quesmana.vue?vue&type=script&lang=js"
import style0 from "./JianKang_quesmana.vue?vue&type=style&index=0&id=468c9c48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "468c9c48",
  null
  
)

export default component.exports